<a mat-button (click)="backClicked()" class="back-button">
    <mat-icon>keyboard_backspace</mat-icon>
    <span>BACK</span>
</a>
